export enum SocketEvent {
  NewPersonalNotification = 'newPersonalNotification',
  ChatbotNewMessage = 'chatbotNewMessage',
  BulkNotesGenerationProgress = 'bulkNotesGenerationProgress',
  BulkNotesGenerationComplete = 'bulkNotesGenerationComplete',
  BulkQuizGenerationProgress = 'bulkQuizGenerationProgress',
  BulkQuizGenerationComplete = 'bulkQuizGenerationComplete',
  SubscriptionUpdated = 'subscriptionUpdated'
}
